import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminImportMedications;

export const adminImportMedicationsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const adminImportMedicationsErrorsSelector = (state: RootState) => getState(state).errors;

export const adminImportSynonymsListLoadingSelector = (state: RootState) =>
  getState(state).isLoadingSynonymsList;
export const adminImportSynonymsListErrorsSelector = (state: RootState) =>
  getState(state).errorsSynonymsList;

export const adminImportHighRiskSupplementsListLoadingSelector = (state: RootState) =>
  getState(state).isLoadingHighRiskSupplementsList;
export const adminImportHighRiskSupplementsListErrorsSelector = (state: RootState) =>
  getState(state).errorsHighRiskSupplementsList;

export const adminImportSupplementsCleanUpListLoadingSelector = (state: RootState) =>
  getState(state).isLoadingSupplementsCleanUpList;
export const adminImportSupplementsCleanUpListErrorsSelector = (state: RootState) =>
  getState(state).errorsSupplementsCleanUpList;

export const adminImportIngredientsCleanUpListLoadingSelector = (state: RootState) =>
  getState(state).isLoadingIngredientsCleanUpList;
export const adminImportIngredientsCleanUpListErrorsSelector = (state: RootState) =>
  getState(state).errorsIngredientsCleanUpList;
